import { ActionHint } from '@ppwr/poker'
import { useStore } from '../../../models'
import { WalkthroughPlayersIds } from '../../../models/game/walkthrough'
import { DealTheFlopStep } from '../../../models/game/walkthrough/deal-the-flop'
import { RaiseOrFoldStep } from '../../../models/game/walkthrough/raise-or-fold'
import { useGameBottomModal } from './useGameBottomModals'
import { triggerHaptic } from '../utils/triggerHaptics/triggerHaptics'

export const usePlayerActions = () => {
  const {
    game: {
      doCallForPlayer,
      doCheckForPlayer,
      doFoldForPlayer,
      doAllInForPlayer,
      setHasUserPreFold,
      modals: { setPlayerActionTimerExpired },
      walkthroughType,
      currentStep,
      setIsBetModalOpen
    },
    permissions: { isSoundEnabled }
  } = useStore()
  const { handleBet: openBetBottomModal, handleWalkthroughAnswer: openWalkthroughAnswerModal } = useGameBottomModal()

  const handlePlayerAction = async (action: ActionHint) => {
    if (isSoundEnabled) {
      triggerHaptic()
    }
    switch (action) {
      case ActionHint.CHECK:
        await doCheckForPlayer()
        break
      case ActionHint.FOLD:
        await doFoldForPlayer()
        setTimeout(() => {
          setHasUserPreFold(false)
        }, 500)
        break
      case ActionHint.ALLIN:
        await doAllInForPlayer()
        break
      case ActionHint.CALL:
        await doCallForPlayer()
        break
      case ActionHint.BET:
      case ActionHint.RAISE:
        setIsBetModalOpen(true)
        openBetBottomModal()
        setPlayerActionTimerExpired(false)
        break
    }
  }

  const handleRaiseAndFoldWalkthroughActions = (action: ActionHint) => {
    if (![ActionHint.FOLD, ActionHint.RAISE].includes(action)) return
    const answer = (currentStep as RaiseOrFoldStep).answer
    openWalkthroughAnswerModal(answer.id === action)
  }

  const handleDealTheFlopWalkthroughActions = (action: ActionHint, selectedPlayerId?: WalkthroughPlayersIds) => {
    const answer = (currentStep as DealTheFlopStep).answer
    openWalkthroughAnswerModal(answer.id === selectedPlayerId)
  }

  return {
    handlePlayerAction:
      walkthroughType === 'RaiseOrFold'
        ? handleRaiseAndFoldWalkthroughActions
        : walkthroughType === 'DealTheFlop'
          ? handleDealTheFlopWalkthroughActions
          : handlePlayerAction
  }
}
